export const EVENT_CATEGORY = '2022WINTERSALE';
export const IS_DEV = process.env.NODE_ENV === 'development';
export const MEDIA_QUERY_LARGE = '(min-width: 768px)';
export const MEDIA_QUERY_SMALL = '(max-width: 767px)';
export const CACHEBUSTER = new Date().getTime();
export const CLEAR_GIF = 'data:image/gif;base64,R0lGODlhAQABAGAAACH5BAEKAP8ALAAAAAABAAEAAAgEAP8FBAA7';
export const IS_MOBILE = window.matchMedia(MEDIA_QUERY_SMALL);
